import { useCallback, useRef } from 'react';

/**
 * Hook for playing notification sound when customer responds
 */
const useNotificationSound = () => {
  const audioRef = useRef<HTMLAudioElement | null>(null);

  const play = useCallback(() => {
    try {
      if (!audioRef.current) {
        audioRef.current = new Audio('/sounds/notification.mp3');
        audioRef.current.volume = 0.5;
      }

      const audio = audioRef.current;
      audio.currentTime = 0;
      audio.play().catch((error) => {
        console.warn('Could not play notification sound:', error);
      });
    } catch (error) {
      console.error('Error playing notification sound:', error);
    }
  }, []);

  return { play };
};

export default useNotificationSound;
